module.exports = __webpack_public_path__ + "img/intro-3.658437be.png";